import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../contexts/AppContext';
import useStableHeight from './useStableHeight';

/**
 * Paging for article blocks with a list and pagination (DM search, Minne). Starts on page 1 for a new search and
 * when idle mode resets the kiosk, and keeps the list at its tallest height so the pagination stays in place
 * @param {unknown} resetKey Value that identifies the search (page 1 and a new height when it changes)
 */
const useBlockPaging = (resetKey: unknown) => {
  const { idleResetCount } = useContext(AppContext);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [listRef, listStyle] = useStableHeight(resetKey);

  useEffect(() => { setCurrentPage(1); }, [resetKey, idleResetCount]);

  return { currentPage, setCurrentPage, listRef, listStyle, idleResetCount };
}

export default useBlockPaging;
